// @ts-nocheck
import { get } from 'lodash';
import root from 'window-or-global';

const getEnvironment = (injectedWindow = window, injectedRoot = root) => {
    const injectedEnvironment = get(injectedRoot, 'window.query.environment');
    if (injectedEnvironment) {
        return injectedEnvironment;
    }
    if (injectedWindow.location.host === 'pdc.servicecare.rio.cloud') {
        return 'production';
    }

    return 'local';
};

export default getEnvironment;
